import router from "../router/index";
import { getToken } from "./jsCookie";
const routerUrl = [];// 白名单
//校验token 免登录
router.beforeEach((to, from, next) => {
    // localStorage.metaobj = JSON.stringify(to.meta || {}); // 存meta,request.js文件使用
    if (getToken()) {
        next();
    } else { // 没有登录
        next();
    }
    // chrome
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
  });